var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon32PxBackpackOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3073 8.61523H19.6914C20.6705 8.61523 21.6096 9.00421 22.302 9.69662C22.9944 10.389 23.3834 11.3281 23.3834 12.3073V27.9986H8.61523V12.3073C8.61523 11.3281 9.00421 10.389 9.69661 9.69662C10.389 9.00421 11.3281 8.61523 12.3073 8.61523Z",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61505 27.9992H4V20.6151C4 20.1255 4.19449 19.6559 4.54069 19.3097C4.88688 18.9635 5.35642 18.769 5.84602 18.769H8.61505",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 18.769H26.1538C26.6434 18.769 27.113 18.9635 27.4591 19.3097C27.8052 19.6559 27.9998 20.1255 27.9998 20.6151V27.9992H23.3848",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61523 16.9229H23.3834",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 15.0764V18.7685",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 8.61509V7.69207C12.3086 6.71288 12.6976 5.77378 13.39 5.08139C14.0824 4.38899 15.0215 4 16.0006 4C16.9798 4 17.9189 4.38899 18.6113 5.08139C19.3037 5.77378 19.6927 6.71288 19.6927 7.69207V8.61509",
    stroke: "CurrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32PxBackpackOutline);
export default __webpack_public_path__ + "static/media/icon_32px_backpack_outline.1c70813bb8226f1f8b8546239bcf001d.svg";
export { ForwardRef as ReactComponent };